import axiosConfig from "./axiosConfig";

// Whether HubSpot actually answers - deliberately not a quota. HubSpot reads cost
// nothing and its daily cap sits orders of magnitude above our use, so a usage figure
// here would only dilute Apollo's genuinely scarce 600/day. What the costs card lacked
// was whether the integration works at all.
//
// `status` is HubSpot's own answer, never "is a token set": a token was present
// throughout the outage where HubSpot had revoked it.
//   connected      - a live authenticated read succeeded; portalId names which CRM
//   not_configured - no token, or HubSpot rejected the one we hold
//   unavailable    - transport error, 5xx, breaker open, or paced out
export interface HubSpotStatusResponse {
  status: "connected" | "not_configured" | "unavailable";
  // Which HubSpot portal this environment reads. Load-bearing on a QA env, where it is
  // the difference between a sandbox and the live customer CRM.
  portalId: string | null;
  // Why it isn't connected, in operator-readable terms. Null when connected.
  detail: string | null;
}

const getHubSpotStatus = async (
  authToken: string
): Promise<HubSpotStatusResponse> => {
  const { data } = await axiosConfig.get(`/leads/hubspot-status`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default getHubSpotStatus;
